import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import  Protected from 'auth/Protected';
import React from 'react';
import { Link } from 'react-router-dom';
import { S } from './KskButton.styles';
import { ApplyTooltip } from '../KskPopover/KskTooltip';

function KskButton({
  type = 'button',
  routerLink,
  label,
  className = '',
  hasValidationErrors,
  icon = '',
  iconRight,
  floatIcon,
  primary,
  secondary,
  success,
  warn,
  danger,
  info,
  small,
  mini,
  large,
  block,
  disabled,
  busy,
  iconButton,
  requires,
  tooltip,
  hidden,
  containerProps,
  ...otherProps
}) {
  const containerClasses = classNames({'has-validation-errors': hasValidationErrors});
  const buttonClasses = [
    'ksk-button br-button block auto-sm ml-sm-2 mb-2',
    className,
    classNames({
      'ksk-button--router-link': routerLink,
      'ksk-button--with-icon' : icon && !iconRight,
      'ksk-button--with-icon-right' : icon && iconRight,
      'primary': primary,
      'secondary': secondary,
      'success': success,
      'warning': warn,
      'danger': danger,
      'info': info,
      'ksk-button--enabled': !disabled,
      'ksk-button--disabled': disabled,
      'ksk-button--mini': mini,
      'small': small,
      'large': large,
      'block': block,
      'circle': iconButton,
      'loading': busy,
    })
  ].join(' ');
  
  const buttonContent = (
    <>
      {(icon && !iconRight) &&
        <span className={classNames('ksk-button__icon', { 'mr-2': !iconButton })} style={{ position: 'relative' }}>
          <FontAwesomeIcon icon={icon} />
          {floatIcon &&
            <span className={`ksk-button__float-icon ksk-button__float-icon--${floatIcon.position}`}>
              <FontAwesomeIcon  icon={floatIcon.icon} />
            </span>}
        </span>
      }
      
      {!iconButton && <span className="ksk-button__label">{ label }</span>}

      {(icon && iconRight) &&
        <span className={'ksk-button__icon ml-2'}>
          <FontAwesomeIcon icon={icon} />
        </span>
      }
    </>
  );

  const _disabled = disabled || busy;
  
  const outputButton = (
    <S.Div className={containerClasses} {...containerProps}> 
      <ButtonWithTooltip
        tooltipProps={tooltip}
        disabled={_disabled}
        routerLink={routerLink}
        buttonClasses={buttonClasses}
        buttonContent={buttonContent}
        hidden={hidden}
        type={type}
        {...otherProps}
      />
    </S.Div>
  );

  return (
    requires?.length
    ? <Protected requires={requires}>{outputButton}</Protected>
    : outputButton
  )
}

/**
 * Necessário porque botões desabilitados não disparam eventos, e por isso tem que ser envoltos
 * em algum wrapper para que os tooltips sejam exibidos sem problemas.
 * @param {*} param0
 * @returns
 */
function ButtonWithTooltip({tooltipProps, disabled, routerLink, buttonClasses, buttonContent, hidden, type, ...otherProps}) {

  // Se tiver router link então deve ser um componente Link do ReactRouter estilizado como um botão
  const element = (
    routerLink
    ? <Link {...otherProps} className={ buttonClasses }>{buttonContent}</Link>
    : <button disabled={disabled} hidden={hidden} className={ buttonClasses } type={type} {...otherProps}>
        {buttonContent}
      </button>
  )

  return (
    // ApplyTooltip irá envolver o elemento em uma tooltip se tooltipProps não for nulo.
    <ApplyTooltip
      tooltipProps={tooltipProps}
      element={
        disabled
        ? <span className="ksk-button__wrapper-for-disabled">{element}</span>
        : element
      }
    />
  );
}

export default KskButton
